import { useCallback } from 'react';
import { useNotificationStore } from '../Notification.store';
import { generateId } from '../helpers/generateId';
import { DEFAULT_NOTIFICATION_DURATION, DEFAULT_NOTIFICATION_POSITION } from '../Notification.constants';
export const useAddNotification = () => {
    const store = useNotificationStore();
    const addNotification = useCallback((notification) => {
        const id = generateId();
        store.addNotification({
            id,
            placement: notification.placement ?? DEFAULT_NOTIFICATION_POSITION,
            ...notification,
        });
        if (notification.autoClose)
            setTimeout(() => store.removeNotification(id), notification.duration ?? DEFAULT_NOTIFICATION_DURATION);
    }, [store]);
    return addNotification;
};
